import { getMapColorScheme } from '@/utils/getMapColorScheme';

export default function GoogleMap(props) {
    const { Map, ColorScheme = 'light', VerticalSpacing = 'medium' } = props;
    const { backgroundClass, blendEffect } = getMapColorScheme(ColorScheme);
    const vSpace = VerticalSpacing === 'large' ? 'h-[48rem]' : 'h-[32rem]';

    const provider = (() => {
        if (Map.includes('google.com/maps/embed')) return 'google';
        if (Map.includes('maptiler.com')) return 'maptiler';
        if (Map.includes('openstreetmap.org')) return 'osm';
        if (Map.includes('here.com') || Map.includes('wego.here.com'))
            return 'here';
        return 'unknown';
    })();

    return (
        <section
            className={`editable-component relative isolate overflow-hidden ${backgroundClass}`}
        >
            <div className={`relative w-full ${vSpace} ${blendEffect}`}>
                <iframe
                    title="Embedded map"
                    className="absolute left-0 top-0 h-full w-full"
                    src={Map}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    {...(provider === 'google' && {
                        loading: 'lazy',
                        referrerPolicy: 'no-referrer-when-downgrade',
                    })}
                ></iframe>
            </div>
        </section>
    );
}
